export default "__VITE_ASSET__LBJHVFhi__"